import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ComplainStatus } from "../types/complaintTypes";

type ComplaintStatusChipProps = {
  status: ComplainStatus;
};

const statusColor = (
  status: ComplainStatus,
): "default" | "error" | "warning" | "success" | "info" => {
  switch (status) {
    case ComplainStatus.opened:
    case ComplainStatus.reopened:
      return "error";
    case ComplainStatus.on_process:
      return "warning";
    case ComplainStatus.closed:
      return "info";
    case ComplainStatus.confirmed:
      return "success";
    default:
      return "default";
  }
};

export const ComplaintStatusChip = ({ status }: ComplaintStatusChipProps) => {
  const { t: te } = useTranslation("enums");
  return (
    <Chip
      size="small"
      label={te(status)}
      color={statusColor(status)}
      variant="outlined"
    />
  );
};
